import React from 'react';

export default function Spinner({ size = 'w-4 h-4', color = 'border-[#fff]' }) {
  return (
    <div
      className={`inline-block animate-spin rounded-full border-[3px] border-t-transparent ${size} ${color}`}
    />
  );
}
